'use strict';

import videojs from 'video.js';

 export default function homePage() {
  const player = videojs('homepage-hero-video');
  const isMuted = $('#homepage-hero-video').attr('muted') || false;
  const autoplay = $('#homepage-hero-video').attr('autoplay');

  player.muted(isMuted).ready(function() {
    if (autoplay) {
      this.play();
    }
  });

}



// WEBPACK FOOTER //
// ./homePage.js